"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleSecondaryPrice = void 0;
const core_1 = require("@angular/core");
const users_service_1 = require("../../../../../shared/users/users.service");
let VehicleSecondaryPrice = class VehicleSecondaryPrice {
    constructor(usersService) {
        this.usersService = usersService;
        this.price = null;
        this.priceDescription = '(Differenzbesteuert nach §25a UStG)';
        this.labelDescription = 'Verkaufspreis';
    }
    ngOnChanges() {
        if (!this.vehicle.vehicleData.price)
            return;
        const { campaignPrice, onlinePrice, includesVat, vatRate, } = this.vehicle.vehicleData.price;
        if (campaignPrice && campaignPrice > 0) {
            this.price = campaignPrice;
            this.priceDescription = 'Verkaufspreis';
        }
        else if (onlinePrice && onlinePrice > 0) {
            this.price = onlinePrice;
            this.priceDescription = 'Onlinepreis';
        }
        else {
            this.priceDescription = 'Verkaufspreis';
            this.price = null;
        }
        this.labelDescription = this.priceDescription;
        if (this.price && includesVat && !this.label) {
            this.priceDescription += ` inkl. ${(vatRate || 0.19) * 100}% MwSt.`;
        }
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleSecondaryPrice.prototype, "vehicle", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], VehicleSecondaryPrice.prototype, "label", void 0);
VehicleSecondaryPrice = __decorate([
    (0, core_1.Component)({
        selector: '[vehicle-secondary-price]',
        template: `
    <ng-container *ngIf="label">
      <span>{{ priceDescription }}&nbsp;</span>
      <span *ngIf="price">{{ price | currency }}</span>
      <span *ngIf="!price">-</span>
    </ng-container>

    <ng-container *ngIf="price && !label">
      {{ price | currency }}

      <svg class="ab-icon cell-icon vmin-tablet-xl"><use xlink:href="#info-light"></use></svg>
      <div class="hover-content left">
        <span>{{ priceDescription }}</span>
      </div>
    </ng-container>
  `,
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _a : Object])
], VehicleSecondaryPrice);
exports.VehicleSecondaryPrice = VehicleSecondaryPrice;
